import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import StoryRail from "@/components/StoryRail";
import PostCard from "@/components/PostCard";
import RightRail from "@/components/RightRail";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Feed() {
  const { user } = useAuth();
  const [tab, setTab] = useState("for-you"); // for-you | following | live
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const params = tab === "following" ? { following: true } : {};
    api
      .get("/posts", { params })
      .then(({ data }) => {
        if (cancelled) return;
        setPosts(data.posts || []);
      })
      .catch(() => !cancelled && setPosts([]))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [tab, user]);

  return (
    <Layout right={<RightRail />}>
      <div data-testid="feed-page">
        <header className="sticky top-0 z-20 bg-[#050505]/90 backdrop-blur-lg border-b border-[#27272A]">
          <div className="flex items-center justify-between px-4 md:px-6 py-4">
            <div>
              <div className="font-mono text-[10px] text-[#FF3E00] tracking-[0.3em] mb-1">
                TIMELINE · LIVE
              </div>
              <h1 className="font-display text-2xl md:text-3xl font-black tracking-tighter uppercase">
                Feed /{" "}
                {tab === "for-you"
                  ? "Para ti"
                  : tab === "following"
                  ? "Siguiendo"
                  : "Live"}
              </h1>
            </div>
            <div className="flex gap-1 border border-[#27272A]">
              {[
                ["for-you", "Para ti"],
                ["following", "Siguiendo"],
                ["live", "Live"],
              ].map(([key, label]) => (
                <button
                  key={key}
                  data-testid={`tab-${key}`}
                  onClick={() => setTab(key)}
                  className={`font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-2 ${
                    tab === key
                      ? "bg-[#FF3E00] text-white"
                      : "text-[#A1A1AA] hover:text-white"
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </header>

        <StoryRail />

        {loading ? (
          <div className="p-10 font-mono text-[11px] uppercase tracking-[0.3em] text-[#A1A1AA]">
            cargando…
          </div>
        ) : posts.length === 0 ? (
          <div className="p-10 border-b border-[#27272A]">
            <div className="font-mono text-[10px] text-[#FF3E00] tracking-[0.3em] mb-2">
              // FEED VACÍO
            </div>
            <h2 className="font-display font-black text-3xl uppercase tracking-tight">
              {tab === "following"
                ? "Aún no sigues a nadie."
                : "Todavía no hay publicaciones."}
            </h2>
            <p className="font-mono text-[11px] text-[#A1A1AA] tracking-wider mt-2">
              {tab === "following"
                ? "Ve a Explorar para encontrar artistas y seguirlxs."
                : "Publica lo primero en el ecosistema."}
            </p>
          </div>
        ) : (
          <div>
            {posts.map((p) => (
              <PostCard key={p.id} post={p} />
            ))}
          </div>
        )}

        <div className="p-10 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA]">
          — fin del feed · vuelve mañana —
        </div>
      </div>
    </Layout>
  );
}
